import { useState } from "react";

import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Elecciones from "../../../images/modulo14/elecciones.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad3Actividad5.mp3";

const Actividad4 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "0" },
    ans2: { value: "", valid: "", correctValue: "1" },
    ans3: { value: "", valid: "", correctValue: "1" },
    ans4: { value: "", valid: "", correctValue: "0" },
    ans5: { value: "", valid: "", correctValue: "1" },
  });

  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[6];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[7].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[7].path}`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[5].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[5].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };

  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Lee el siguiente texto y observa la imagen.</li>
      </ul>
      <div className="row">
        <div className="col-lg-10 col-12 ps-4">
          <div className="shadow-sm rounded border border-1 p-4 mb-4">
            <p className="mb-0 fs-5">
              Recién en las elecciones de 1980, los analfabetos (las personas
              que no saben leer ni escribir) pudieron votar. La mayoría de
              analfabetos eran campesinos que no hablaban castellano y tampoco
              lo leían ni escribían.{" "}
            </p>
            <img src={Elecciones} className="img-fluid mt-2" alt="Elecciones" />
          </div>
        </div>
      </div>
      <ul className="my-4">
        <li>
          Ahora lee las siguientes afirmaciones y marca las que correspondan a
          hechos y deja sin marcar las que sean una opinión
        </li>
      </ul>
      <div className="row align-items-center mb-3">
        <div className="col-1 offset-md-1">
          <input
            className={"form-check-input mb-1 form-md " + answers.ans1.valid}
            type="checkbox"
            value="1"
            checked={answers.ans1.value === "1"}
            onChange={(event) => handleAnswers(event, "ans1")}
          />{" "}
        </div>
        <div className="col-8">
          Solo deberían votar en las elecciones personas con estudios.
        </div>
      </div>
      <div className="row align-items-center mb-3">
        <div className="col-1 offset-md-1">
          <input
            className={"form-check-input mb-1 form-md " + answers.ans2.valid}
            type="checkbox"
            value="1"
            checked={answers.ans2.value === "1"}
            onChange={(event) => handleAnswers(event, "ans2")}
          />{" "}
        </div>
        <div className="col-8">
          En las últimas elecciones, votaron personas que sabían leer y también
          personas que no sabían leer.
        </div>
      </div>
      <div className="row align-items-center mb-3">
        <div className="col-1 offset-md-1">
          <input
            className={"form-check-input mb-1 form-md " + answers.ans3.valid}
            type="checkbox"
            value="1"
            checked={answers.ans3.value === "1"}
            onChange={(event) => handleAnswers(event, "ans3")}
          />{" "}
        </div>
        <div className="col-8">
          Todos los peruanos mayores de 18 años tenemos derecho a votar.
        </div>
      </div>
      <div className="row align-items-center mb-3">
        <div className="col-1 offset-md-1">
          <input
            className={"form-check-input mb-1 form-md " + answers.ans4.valid}
            type="checkbox"
            value="1"
            checked={answers.ans4.value === "1"}
            onChange={(event) => handleAnswers(event, "ans4")}
          />{" "}
        </div>
        <div className="col-8">
          Está bien que los analfabetos voten, pero no que sean elegidos como
          autoridades.
        </div>
      </div>
      <div className="row align-items-center mb-3">
        <div className="col-1 offset-md-1">
          <input
            className={"form-check-input mb-1 form-md " + answers.ans5.valid}
            type="checkbox"
            value="1"
            checked={answers.ans5.value === "1"}
            onChange={(event) => handleAnswers(event, "ans5")}
          />{" "}
        </div>
        <div className="col-8">
          La mayoría de analfabetos en el Perú son mujeres.
        </div>
        <div className="col-10">
        <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo14.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

        </div>
      </div>

      
      <div className="row mt-5">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Compara tus respuestas un compañero, compañera o familiar. Ahora
              conversen sobre las siguientes preguntas y escriban aquí sus
              respuestas:
            </li>
          </ul>
          <p>
            ¿Dónde podrían buscar información para comprobar si los hechos
            mencionados son ciertos?
          </p>
          <textarea className="form-control mb-4" rows="4" />

          <p>
            ¿Qué piensan acerca de las opiniones presentadas? ¿Están de acuerdo
            con ellas? ¿Por qué?
          </p>
          <textarea className="form-control mb-4" rows="4" />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que en las siguientes actividades conversaran con sus
            compañeros, compañeras o familiar sobre un problema que muchas veces
            pasa desapercibido en el país: la discriminación lingüística.
          </li>
          <li>
            Pida que observen la ilustración y la describan. Lea la primera
            indicación: Lee el siguiente texto y observa la imagen. Recién en
            las elecciones de 1980, los analfabetos (las personas que no saben
            leer ni escribir) pudieron votar. La mayoría de analfabetos eran
            campesinos que no hablaban castellano y tampoco lo leían ni
            escribían. Pregunte: ¿Por qué creen que antes los
            analfabetos no votaban? Comente que se consideraba que los
            analfabetos, por no saber leer ni escribir, podían ser fácilmente
            manipulados (convencidos de votar por alguna opción). Detrás de esta
            afirmación se escondía la discriminación hacia la población
            indígena.
          </li>
          <li>
            Lea la siguiente indicación: Ahora lee las siguientes afirmaciones y
            marca las que correspondan a hechos y deja sin marcar las que sean
            una opinión. Recuerda que un hecho es algo que se puede comprobar y
            una opinión es un juicio o una valoración. Pida que lean las
            oraciones. Déles un tiempo para trabajar individualmente y pase a la
            siguiente actividad.
          </li>
          <li>
            Lea la indicación. Dé un tiempo para que trabajen y luego revise la
            actividad retomando sus respuestas. Por ejemplo:
            <ul>
              <li>
                <i>
                  “¿Qué oraciones representan hechos? (Posible respuesta: la
                  segunda, tercera y quinta oración. Para confirmar esta opinión
                  se puede acudir a la ONPE).{" "}
                </i>
              </li>
              <li>
                <i>
                  ¿Qué oraciones corresponden a opiniones? (Posible respuesta:
                  La primera y segunda oración).
                </i>
              </li>
            </ul>
          </li>
          <li>
            Es importante que resalte que ambas opiniones son discriminatorias y
            no reconocen a las personas como ciudadanos con iguales derechos y
            deberes.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
